import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { DataService_Attendance } from "../shared/data.service";
import { StudentAddAttendanceComponent } from "./student-add-attendance/student-add-attendance.component";
import { StudentEditAttendanceComponent } from "./student-edit-attendance/student-edit-attendance.component";
import { StudentPrintAttendanceComponent } from "./student-print-attendance/student-print-attendance.component";
import * as moment from "moment";

@Component({
	selector: "caass-attendance-info",
	templateUrl: "./attendance-info.component.html",
	styleUrls: ["./attendance-info.component.css"],
})
export class AttendanceInfoComponent implements OnInit {
	constructor(private userService: UserService, private AttendanceTempService: DataService_Attendance, private dialogService: DialogService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		if (this.Person != undefined && this.StartDate != undefined && Date.parse(this.StartDate) && this.EndDate != undefined && Date.parse(this.EndDate)) {
			this.loadAttendance();
		}
	}

	ngOnChanges() {
		if (this.Person != undefined && this.StartDate != undefined && Date.parse(this.StartDate) && this.EndDate != undefined && Date.parse(this.EndDate)) {
			this.onRowUnselect(null);
			this.loadAttendance();
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() AttendanceSelected: EventEmitter<any> = new EventEmitter();
	@Output() AttendanceChanged: EventEmitter<any> = new EventEmitter();

	//Data from parent
	@Input() Person: any;
	@Input() StartDate: any;
	@Input() EndDate: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedAttendance: any;
	lstAttendance: any = [];

	//Filter lists
	lstEntryDayDesc: any = [];
	lstStatusDescription: any = [];
	lstMethodDescription: any = [];
	lstExcuseDescription: any = [];
	lstRecordStatusDesc: any = [];
	lstc_personName: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "EntryDateDesc", header: "Date" },
		{ field: "EntryTime", header: "Time" },
		{ field: "EntryDayDesc", header: "Day" },
		{ field: "StatusDescription", header: "Status" },
		{ field: "ExcuseDescription", header: "Excuse/Reason" },
		{ field: "MethodDescription", header: "Entry Method" },
		{ field: "c_comment", header: "Comments" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadAttendance() {
		this.loading = true;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		var result = this.AttendanceTempService.LoadAttendance(this.Person.PersonID, fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstAttendance = response;

				//Update Values
				for (var i = 0; i < this.lstAttendance.length; i++) {
					var next = this.lstAttendance[i];

					next.EntryDateDesc = moment(next.EntryDate).format("MM/DD/YYYY");
					next.EntryDayDesc = this.IntToDay(new Date(next.EntryDate).getDay());
					next.EntryTime = moment(next.EntryTime).format("h:mm:ss a");
				}

				//Load Data Filter Lists
				this.lstEntryDayDesc = Array.from(new Set(this.lstAttendance.map((item: any) => item.EntryDayDesc))).sort();
				this.lstStatusDescription = Array.from(new Set(this.lstAttendance.map((item: any) => item.StatusDescription))).sort();
				this.lstMethodDescription = Array.from(new Set(this.lstAttendance.map((item: any) => item.MethodDescription))).sort();
				this.lstExcuseDescription = Array.from(new Set(this.lstAttendance.map((item: any) => item.ExcuseDescription))).sort();
				this.lstRecordStatusDesc = Array.from(new Set(this.lstAttendance.map((item: any) => item.RecordStatusDesc))).sort();
				this.lstc_personName = Array.from(new Set(this.lstAttendance.map((item: any) => item.c_personName))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadAttendance();
	}

	//Custom Button Methods
	onAddAttendance() {
		this.errorMessage = "";

		var ref = this.dialogService.open(StudentAddAttendanceComponent, {
			header: "Add Attendance",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.Person.SchoolID,
				SelectedPerson: this.Person,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadAttendance();
				this.AttendanceChanged.emit(1);
			}
		});
	}

	onEditAttendance() {
		this.errorMessage = "";

		if (this.SelectedAttendance == undefined) {
			this.errorMessage = "Select an attendance record to edit";
			return;
		}

		var ref = this.dialogService.open(StudentEditAttendanceComponent, {
			header: "Edit Attendance",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.Person.SchoolID,
				SelectedPerson: this.Person,
				SelectedAttendance: this.SelectedAttendance,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadAttendance();
				this.AttendanceChanged.emit(1);
			}
		});
	}

	onPrintAttendance() {
		this.errorMessage = "";

		if (this.Person == undefined) {
			this.errorMessage = "Select a person to print reports for";
			return;
		}

		var ref = this.dialogService.open(StudentPrintAttendanceComponent, {
			header: "Print Attendance",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.Person.SchoolID,
				SelectedPerson: this.Person,
				StartDate: this.StartDate,
				EndDate: this.EndDate,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadAttendance();
			}
		});
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedAttendance = val.data;

		this.AttendanceSelected.emit(this.SelectedAttendance);
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedAttendance = null;

		this.AttendanceSelected.emit(this.SelectedAttendance);
	}
	onRowDblClick(Attendance) {
		this.errorMessage = "";

		this.SelectedAttendance = Attendance;
		this.onEditAttendance();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	IntToDay(i) {
		if (i == 0) {
			return "Sun";
		} else if (i == 1) {
			return "Mon";
		} else if (i == 2) {
			return "Tue";
		} else if (i == 3) {
			return "Wed";
		} else if (i == 4) {
			return "Thu";
		} else if (i == 5) {
			return "Fri";
		} else if (i == 6) {
			return "Sat";
		}
	}
	////////////////////////////////////////////
}
